// Admin configuration
export const ADMIN_EMAIL = 'IC@INDIANACHAKRA.COM';
export const ADMIN_PASSWORD = 'LiberadoAdmin!2025';
export const ADMIN_RESET_CODE = 'LIBERADO-RESET-2025';

// Public routes that don't require authentication
export const PUBLIC_ROUTES = [
  '/',
  '/about',
  '/interes',
  '/interest',
  '/interesse',
  '/for-clinics',
  '/for-technicians',
  '/ai-powered',
];

// Protected routes that require admin access (obfuscated)
export const PROTECTED_ROUTES = [
  '/liberado-jefe-clinic',
  '/liberado-jefe-tech',
  '/liberado-jefe',
  '/liberado-jefe-dashboard',
  '/liberado-jefe-test',
  '/liberado-jefe-login',
];

// Old routes that should redirect to /interes
export const DEPRECATED_ROUTES = [
  '/admin',
  '/admin-login',
  '/clinic',
  '/technician',
  '/dashboard',
  '/test-mode',
  '/login',
  '/signup',
];
